import React from 'react';
type StatCardProps = {
  label: string;
  value: string;
  caption: string;
  tone?: 'default' | 'danger' | 'success' | 'warn';
  icon?: React.ElementType;
};
const cardTone = {
  default: 'border-gray-200 bg-white',
  danger: 'border-danger/40 bg-white',
  success: 'border-success/30 bg-success-soft/40',
  warn: 'border-amber-200 bg-amber-50/50'
} as const;
const valueTone = {
  default: 'text-ink',
  danger: 'text-danger',
  success: 'text-success',
  warn: 'text-amber-700'
} as const;
const iconTone = {
  default: 'bg-gray-100 text-gray-600',
  danger: 'bg-danger-soft text-danger',
  success: 'bg-success-soft text-success',
  warn: 'bg-amber-100 text-amber-700'
} as const;
export function StatCard({
  label,
  value,
  caption,
  tone = 'default',
  icon: Icon
}: StatCardProps) {
  return <div className={['rounded-xl border px-5 py-4', cardTone[tone]].join(' ')} data-id="element-676" data-mp="1zzw4uq7cc6el">
      <div className="flex items-center gap-2" data-id="element-677" data-mp="1v0sy91bpps4i">
        <p className="text-[11px] font-semibold uppercase tracking-wider text-gray-500" data-id="element-678" data-mp="1v12ngmoxnv95">
          {label}
        </p>
        {Icon && <span className={['ml-auto flex h-7 w-7 items-center justify-center rounded-lg', iconTone[tone]].join(' ')} data-id="element-679" data-mp="sx81mt0tdd0p">
            <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-680" data-mp="ezrybqdtdzd6" />
          </span>}
      </div>
      <p className={['mt-2 text-3xl font-bold leading-none', valueTone[tone]].join(' ')} data-id="element-681" data-mp="jycxdmhbyd01">
        {value}
      </p>
      <p className={['mt-3 text-[12px]', tone === 'danger' ? 'text-danger' : 'text-gray-500'].join(' ')} data-id="element-682" data-mp="1ckxpwq9jkv56">
        {caption}
      </p>
    </div>;
}